var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    {
      staticClass: "text-xs-center",
      staticStyle: { "margin-top": "10%" },
      attrs: { fluid: "" }
    },
    [
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "" } },
        [
          _c(
            "v-flex",
            { staticClass: "text-xs-center", attrs: { xs12: "", "mt-5": "" } },
            [_c("h1", [_vm._v("Sign In")])]
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm6: "", "offset-sm3": "", "mt-3": "" } },
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      return _vm.userSignIn.apply(null, arguments)
                    }
                  }
                },
                [
                  _c(
                    "v-layout",
                    { attrs: { column: "" } },
                    [
                      _c(
                        "v-flex",
                        [
                          _c(
                            "v-alert",
                            {
                              attrs: { type: "error", dismissible: "" },
                              model: {
                                value: _vm.alert,
                                callback: function($$v) {
                                  _vm.alert = $$v
                                },
                                expression: "alert"
                              }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.error) +
                                  "\n            "
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.errorMessage
                        ? _c(
                            "div",
                            {
                              staticClass: "alert alert-danger",
                              attrs: { role: "alert" }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.errorMessage) +
                                  "\n          "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        [
                          _c("v-text-field", {
                            attrs: {
                              name: "email",
                              label: "Email",
                              id: "email",
                              type: "email",
                              rules: _vm.emailRules,
                              "prepend-icon": "mail",
                              autocomplete: "on",
                              required: ""
                            },
                            model: {
                              value: _vm.email,
                              callback: function($$v) {
                                _vm.email = $$v
                              },
                              expression: "email"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        [
                          _c("v-text-field", {
                            attrs: {
                              name: "password",
                              label: "Password",
                              id: "password",
                              "prepend-icon": "vpn_key",
                              autocomplete: "on",
                              "append-icon": _vm.showPassword
                                ? "visibility"
                                : "visibility_off",
                              type: _vm.showPassword ? "text" : "password",
                              rules: _vm.passwordRules,
                              required: ""
                            },
                            on: {
                              "click:append": function($event) {
                                _vm.showPassword = !_vm.showPassword
                              }
                            },
                            model: {
                              value: _vm.password,
                              callback: function($$v) {
                                _vm.password = $$v
                              },
                              expression: "password"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        {
                          staticClass: "text-xs-center",
                          attrs: { "mt-4": "" }
                        },
                        [
                          _c(
                            "v-btn",
                            { attrs: { color: "primary", type: "submit" } },
                            [_vm._v(" Sign In")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        {
                          staticClass: "text-xs-center",
                          attrs: { "mt-4": "" }
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "google-btn",
                              attrs: { type: "button" },
                              on: { click: _vm.googleSignIn }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "google-icon-wrapper" },
                                [
                                  _c("img", {
                                    staticClass: "google-icon",
                                    attrs: {
                                      src:
                                        "https://upload.wikimedia.org/wikipedia/commons/5/53/Google_%22G%22_Logo.svg"
                                    }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c("p", { staticClass: "btn-text" }, [
                                _c("b", [_vm._v("Sign in with google")])
                              ])
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        {
                          staticClass: "text-xs-center",
                          attrs: { "mt-3": "" }
                        },
                        [
                          _c(
                            "p",
                            [
                              _vm._v(
                                "\n              Don't have an account yet?\n              "
                              ),
                              _c("router-link", { attrs: { to: "/signup" } }, [
                                _vm._v("Sign Up")
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("router-link", { attrs: { to: "/forgot" } }, [
                            _vm._v("Forgot your password?")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2b7a3d48", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b7a3d48","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Signin.vue
// module id = null
// module chunks = 